import { Check, CheckStatus, CheckStageDTO } from "./checks-model";
import { DocumentModel } from "./document-model";
import { User } from "./user-model";

/**
 * CommentDTO – Backend-API-Response für:
 *   GET /api/check/{id}/comment
 *   GET /api/check/{id}/stage/{stageId}/comment
 *   GET /api/comment/{id}
 */
export interface CommentDTO {
  guid: string;
  author: { oid: string; displayName: string };
  createdAt: string;
  modifiedAt: string;
  text: string;
  isDone: boolean;
  /**
   * Severity-Werte:
   *   "WARNING"  – Normaler Prüfkommentar (Standard, Wiedervorlage)
   *   "CRITICAL" – Prüfung nicht möglich (isCheckImpossible: true)
   *   "INFO"     – Informationskommentar (kein Handlungsbedarf)
   *   "HINT"     – Interner Hinweis, wird im UI nicht angezeigt
   */
  severity: string;
  /** Nur bei /check/{id}/comment befüllt – gibt an, zu welchem Stage der Kommentar gehört */
  stage?: CheckStageDTO;
}

/** CommentModel – Frontend-Domain-Modell */
export interface CommentModel {
  id: string;
  /** Mapped von CommentDTO.text */
  content: string;
  status: commentStatus;
  createdAt: string;
  severity: string;
  isDone: boolean;
  check: Check;
  checkStatus: CheckStatus;
  /** Bleibt leer – Kommentare sind in der neuen API nicht direkt an Dokumente gebunden */
  documents: DocumentModel[];
  author: User;
  isCheckImpossible?: boolean;
}

export enum commentStatus {
  tbd = 0,
  done = 1,
  info = 2,
  archive = 3
}

/** Hilfsfunktion: Mappt CommentDTO-Felder auf commentStatus */
export function mapCommentStatus(isDone: boolean, severity: string): commentStatus {
  if (severity === 'INFO') return commentStatus.info;
  // CRITICAL (Prüfung nicht möglich) und WARNING: isDone bestimmt den Status
  // HINT wird vor dem Mapping herausgefiltert und sollte hier nicht ankommen
  return isDone ? commentStatus.done : commentStatus.tbd;
}

// --- Backend API DTOs (Request Payloads) ---

export interface CommentCreateDTO {
  text: string;
  isDone?: boolean;
  severity?: string;
}

export interface CommentUpdateDTO {
  text?: string;
  isDone?: boolean;
  severity?: string;
}

/**
 * CommentRoleRequest – Request-Body für POST /document/{documentId}/comment/{commentId}.
 * Verknüpft einen bestehenden Kommentar mit einem Dokument.
 * visibility entspricht dem C# VisibilityType-Enum (Integer):
 *   0 = PROJECT (default)
 * @todo Weitere VisibilityType-Werte mit Backend klären.
 */
export interface CommentRoleRequest {
  visibility: number;
}

